"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpacing = getSpacing;

var _core = require("@styled-system/core");

function getSpacing(index) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (_ref) {
    var theme = _ref.theme;
    var spacing = (0, _core.get)(theme, "space.".concat(index));
    return suffix ? "".concat(spacing, "px") : spacing;
  };
}
/* eslint-enable no-redeclare */